import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';
import { deriveDownloadFilename } from '@/utils/download-filename';

const $t = i18n.t.bind(i18n);

export const encodeGcsPathSegment = (segment: string): string =>
  encodeURIComponent(segment).replace(
    /[!*'()]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
  );

export const useDownloadExportSdses = () => {
  const getParamsFromQuery = () => {
    const queryParams = new URLSearchParams(location.href.split('?')[1]);

    return {
      hasExport: Boolean(queryParams.get('export')),
      bucket: queryParams.get('bucket'),
      companyId: queryParams.get('companyId'),
      filename: queryParams.get('filename'),
      // ダウンロード時に保存させる表示名。エクスポート実行時の言語・種別で
      // ワーカーが決定しメールリンクに付与する (旧リンクには存在しない)
      displayFilename: queryParams.get('displayFilename'),
      googleQuery: {
        'X-Goog-Algorithm': queryParams.get('X-Goog-Algorithm') ?? '',
        'X-Goog-Credential': queryParams.get('X-Goog-Credential') ?? '',
        'X-Goog-Date': queryParams.get('X-Goog-Date') ?? '',
        'X-Goog-Expires': queryParams.get('X-Goog-Expires') ?? '',
        'X-Goog-SignedHeaders': queryParams.get('X-Goog-SignedHeaders') ?? '',
        'X-Goog-Signature': queryParams.get('X-Goog-Signature') ?? '',
      },
    };
  };

  const validateParams = ({
    bucket,
    companyId,
    filename,
  }: ReturnType<typeof getParamsFromQuery>) => bucket && companyId && filename;

  const downloadExportData = async (
    params: ReturnType<typeof getParamsFromQuery>
  ) => {
    const { bucket, companyId, filename, displayFilename, googleQuery } =
      params;
    const link = document.createElement('a');
    const urlSearchParam = new URLSearchParams(googleQuery).toString();
    const url = `https://storage.googleapis.com/${bucket}/export/${companyId}/${encodeGcsPathSegment(
      filename ?? ''
    )}?${urlSearchParam}`;
    const response = await fetch(url);
    const blob = await response.blob();
    const newBlob = new Blob([blob]);
    const objUrl = window.URL.createObjectURL(newBlob);
    link.href = objUrl;

    // displayFilename があればそれを最優先 (エクスポート実行時の言語・種別で
    // ワーカーが決めた名前)。無い旧リンクは filename から導出し、導出できない
    // 新形式 ({job_id}.xlsx / {job_id}.csv) は現在のUI言語の既定名で保存する
    link.download =
      displayFilename ||
      deriveDownloadFilename(filename, $t(sharedMessages.sdsList) as string);
    link.click();
  };

  const downloadExportSdses = async () => {
    const params = getParamsFromQuery();
    if (!params.hasExport) {
      return;
    }

    if (!validateParams(params)) {
      throw new Error('there are not exist needed paramater');
    }

    await downloadExportData(params);
  };

  return {
    downloadExportSdses,
  };
};
